import { Grid, LinearProgress, Stack, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import { useState } from 'react';
import { dateDisplay } from '../Helpers/dateDisplay';
import { getSessionWeekDay } from '../Helpers/getSessionWeekDay';
import { isSessionToday } from '../Helpers/isSessionToday';
import { SessionWithId } from '../Models/session';
import { Chips } from './Chips';
import { SessionDialog } from './SessionDialog';

interface sessionItemProps {
    session: SessionWithId;
    onSessionClick?: (session: SessionWithId) => void;
    login?: boolean;
}

export const SessionItem: React.FC<sessionItemProps> = ({
    session,
    onSessionClick,
    login,
}) => {
    const [openDialog, setOpenDialog] = useState(false);

    const closeDialog = () => {
        setOpenDialog(false);
    };

    const isToday = isSessionToday(session);

    const openConfirmationDialog = () => {
        setOpenDialog(true);
    };

    const onConfirmHandler = () => {
        if (onSessionClick) {
            onSessionClick(session);
        }
        closeDialog();
    };

    const sessionClickHandler = (e: any) => {
        if (login !== undefined) {
            openConfirmationDialog();
        } else if (login === undefined && onSessionClick) {
            onSessionClick(session);
        }
    };

    return (
        <>
            {login !== undefined && (
                <SessionDialog
                    action={onConfirmHandler}
                    close={closeDialog}
                    login={login}
                    open={openDialog}
                    session={session}
                />
            )}
            <Grid
                item
                container
                justifyContent="center"
                alignItems="center"
                onClick={sessionClickHandler}
                sx={{
                    background: session.session.special
                        ? '#FF6F66'
                        : green[500],
                    margin: '10px',
                    borderRadius: '20px',
                    minHeight: '70px',
                    maxHeight: '70px',
                    width: '90%',

                    '&:hover': {
                        background: green[700],
                        cursor: 'pointer',
                    },
                }}
            >
                <Stack>
                    <Chips session={session} />
                    <Grid container direction="row" spacing={2}>
                        <Grid item>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 'bold' }}
                                color="primary.main"
                            >
                                {dateDisplay(session.session)}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 'bold' }}
                                color="primary.main"
                            >
                                ({getSessionWeekDay(session.session, 'cs-Cz')})
                            </Typography>
                        </Grid>
                    </Grid>
                    <LinearProgress
                        variant="determinate"
                        value={
                            session.session.people
                                ? Math.min(
                                      (Object.keys(session.session.people)
                                          .length /
                                          session.session.capacity) *
                                          100,
                                      100,
                                  )
                                : 0
                        }
                        color="warning"
                    />
                </Stack>
            </Grid>
        </>
    );
};
